import React from 'react';
import GlobalStyle from '../assets/global.style';
import SimpleHeader from '../components/SimpleHeader-comp/simpleheader';
import PrivacyPolicyContent from '../components/PrivacyPolicyContent-comp/privacypolicycontent';
import Footer from '../components/Footer-comp/footer';


function PrivacyPolicy() {
  return (

      <div className="App">
        <GlobalStyle/>
        <SimpleHeader/>
        <PrivacyPolicyContent/>
        <Footer/>
      </div>
    
  );
}

export default PrivacyPolicy;